import { render } from "./FormInput.vue?vue&type=template&id=2c6cdb5d"
import script from "./FormInput.vue?vue&type=script&lang=ts"
export * from "./FormInput.vue?vue&type=script&lang=ts"
script.render = render

export default script